module.exports = __webpack_public_path__ + "static/media/python.5956c886.png";